import OrderDetailContext, {OrderDetailController, useOrderDetailContext} from "../../../../../reducer/moduleReducer/my/orderDetail";
import {HeaderMall9} from "../../../../../publicComponent/Header";
import Navigator from "../../../../../publicComponent/h5/Navigator";
import Button from "../../../../../publicComponent/Button";
import {Fragment, useLayoutEffect, useRef, useState} from "react";
import WhiteSpec from "../../../../../publicComponent/h5/WhiteSpec";
import { useTranslation } from "react-i18next";

const gradeList = [
  {
    text: '好评',
    value: '1',
  },
  {
    text: '中评',
    value: '2',
  },
  {
    text: '差评',
    value: '3',
  }
];

function Grade({ gradeHandle, grade, index }) {
  const {t} = useTranslation()
  return (
    <div>
      {
        gradeList.map((item, i) => (
          <p className={'cursor-pointer inline-block border-[1px] py-[3px] px-[15px] mr-[10px] text-[13px] my-[5px] ' + (item.value === grade ? 'text-white bg-[#333] border-[#333]' : '')}
             onClick={() => gradeHandle(item.value, index)}
             key={item.value}>{t(item.text)}</p>
        ))
      }
    </div>
  );
}

function Stars({ starHandle, star, index }) {
  return (
    <div>
      {
        [1, 2, 3, 4, 5].map((item, i) => (
          <i className={'cursor-pointer iconfont text-[24px] mr-[8px] icon-star ' + (i <= star ? 'icon-star-fill text-[#FFC75A]' : 'text-[#aaa]')}
             key={item}
             onClick={() => starHandle(i, index)}/>
        ))
      }
    </div>
  );
}

function OrderCommentWrap() {
  const { getOrderDetailComment, starHandle, gradeHandle, commentHandle, submitComment } = OrderDetailController();
  const { state } = useOrderDetailContext();
  const { orderComment } = state;
  const textarea = useRef(null);
  const {t} = useTranslation()
  
  useLayoutEffect(() => {
    if (textarea.current) {
      setTimeout(() => {
        textarea.current.focus();
      }, 50);
    }
    getOrderDetailComment();
  }, []);
  
  return (
    <Navigator.container className="container-center">
      <div className="bg-white mdmax:pt-[25px] py-[8px] flex-1 md:p-[40px] md:w-[50%]">
        {
          state.detail.productList && orderComment.length > 0 &&
          state.detail.productList.map((goods, i) => (
            <Fragment key={i}>
              <div className="px-[15px]">
                <div className="mb-[12px] flex">
                  <img src={goods.imgPathView}
                       className="w-[45px] h-[45px] md:w-[75px] md:h-[75px] rounded-[5px] mr-[12px]"/>
                  <div className="content">
                    <p className="text-[13px]">{goods.productName}</p>
                    <p className="text-[13px] text-[#999]">x{goods.productQty}</p>
                  </div>
                </div>
                <Grade gradeHandle={gradeHandle} grade={orderComment[i].grade} index={i}/>
                <Stars starHandle={starHandle} star={orderComment[i].starNum} index={i}/>
                <textarea ref={textarea}
                          onChange={(e) => commentHandle(e.target.value, i)}
                          placeholder={t('请输入评价')}
                          className="w-[100%] border-[1px] resize-none p-[12px] mb-[12px]"/>
              </div>
              <WhiteSpec/>
            </Fragment>
          ))
        }
    
        <div className="mx-[15px]">
          <Button onClick={submitComment}
                  className="w-[100%] mt-[10px] bg-[#333] text-white rounded-[5px] py-[8px] text-[14px]">{t('评价')}</Button>
        </div>
      </div>
    </Navigator.container>
  );
}

export default function OrderComment() {
  return (
    <>
      <HeaderMall9/>
      <Navigator title={'订单评价'} goback/>
      <OrderDetailContext>
        <OrderCommentWrap/>
      </OrderDetailContext>
    </>
  );
}
